import React from 'react';
import { useInstructor } from '../context/InstructorContext';
import { Bell, User, Menu } from 'lucide-react';

const Header = ({ title, setIsSidebarOpen, isDesktop }) => {
    const { instructorProfile, branches } = useInstructor();

    // Get instructor name or fallback
    const instructorName = instructorProfile?.first_name
        ? `${instructorProfile.first_name} ${instructorProfile.last_name || ''}`
        : 'Instructor';

    // Get current branch name (check id or branch_id)
    const currentBranch = branches.find(b => String(b.id || b.branch_id) === String(instructorProfile?.branch_id));
    const branchName = currentBranch?.branch_name || currentBranch?.name || 'All Branches';

    return (
        <header style={{
            height: '80px',
            backgroundColor: 'var(--white)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: isDesktop ? '0 32px' : '0 16px',
            borderBottom: '1px solid #e5e7eb',
            position: 'sticky',
            top: 0,
            zIndex: 10
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                {!isDesktop && (
                    <button
                        onClick={() => setIsSidebarOpen(true)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px' }}
                    >
                        <Menu size={24} color="var(--text-primary)" />
                    </button>
                )}
                <h1 style={{ fontSize: isDesktop ? '24px' : '18px', color: 'var(--text-primary)', margin: 0 }}>{title}</h1>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: isDesktop ? '32px' : '16px' }}>
                {isDesktop && (
                    <>
                        {/* Branch Display (Fixed to Instructor's Branch) */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#9CA3AF' }}>BRANCH</span>
                            <div style={{
                                padding: '8px 12px',
                                borderRadius: '6px',
                                border: '1px solid #e5e7eb',
                                fontWeight: '600',
                                color: 'var(--text-primary)',
                                backgroundColor: '#f9fafb',
                                minWidth: '120px'
                            }}>
                                {branchName}
                            </div>
                        </div>

                        {/* Date Range dummy */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            backgroundColor: '#f9fafb',
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: '1px solid #e5e7eb'
                        }}>
                            <span style={{ fontSize: '14px', color: '#6B7280' }}>FROM: 01/01/2026</span>
                            <span style={{ fontSize: '14px', color: '#6B7280' }}>TO: 31/10/2026</span>
                        </div>
                    </>
                )}

                {/* Profile / Notifications */}
                <div style={{ display: 'flex', alignItems: 'center', gap: isDesktop ? '20px' : '12px' }}>
                    <button style={{ position: 'relative', background: 'none', border: 'none', cursor: 'pointer' }}>
                        <Bell size={20} color="var(--text-primary)" />
                        <span style={{
                            position: 'absolute',
                            top: '-2px',
                            right: '-2px',
                            width: '8px',
                            height: '8px',
                            backgroundColor: 'var(--danger)',
                            borderRadius: '50%'
                        }}></span>
                    </button>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        {isDesktop && (
                            <div style={{ textAlign: 'right' }}>
                                <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{instructorName}</div>
                                <div style={{ fontSize: '12px', color: '#6B7280' }}>Instructor</div>
                            </div>
                        )}
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: '#e5e7eb',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer'
                        }}>
                            <User size={20} color="#6B7280" />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
